<template>
  <ion-content id="app" class="ion-padding">

    <a href="/#/box/new/">Neue Box erstellen</a>

    <ion-list>
      <ion-item v-for="box in allBoxes" :key="box.id"  :href="['/#/box/edit/' + box.id + '/']">
        <ion-label>{{ box.title }}</ion-label>
        <a :href="['/#/link/list/' + box.id + '/']">
          <ion-icon name="apps"></ion-icon>
        </a>
        <a :href="['/#/box/edit/' + box.id + '/']">
          <ion-icon name="build"></ion-icon>
        </a>
        <ion-icon name="trash" @click="runDeleteBox(box)"/>
      </ion-item>
    </ion-list>

  </ion-content>
</template>

<script>

  import {mapActions, mapGetters} from "vuex";


  export default {
    name: "BoxList",
    data(){
      return {
      }
    },
    methods: {
      ...mapActions([ "getBoxes", "deleteBox" ]),
      runDeleteBox(box) {
        this.deleteBox(box);
      }
    },
    computed: mapGetters(["allBoxes"]),
    created() {
      this.getBoxes();
    }
  };
</script>

<style scoped>
  ion-list {
    --background: #3E4143;
    padding: 0;
    margin-top: 40px;
  }

  ion-icon {
    margin-left: 20px;
  }
</style>
